interface Props {
  shouldDoubleOpt: boolean;
  signupFlowId?: string;
  automationIds?: string;
}

const ServerSideInputs = ({ shouldDoubleOpt, signupFlowId, automationIds }: Props) => {
  return (
    <>
      <input name="sent_from_orchid" type="hidden" value="true" />
      <input name="signup_flow_id" type="hidden" value={signupFlowId} />
      <input name="automation_ids" type="hidden" value={automationIds} />
      <input name="double_opt" type="hidden" value={shouldDoubleOpt?.toString()} />
    </>
  );
};

export default ServerSideInputs;
